import { useEffect, useState } from 'react';

import { Button } from '../../../common/button/Button';
import { Input } from '../../../common/input/Input';

const redistribute = (slots) => {
  if (!slots.length) return slots;
  const share = +(100 / slots.length).toFixed(2);
  return slots.map((s, i) => ({
    ...s,
    percent: i === slots.length - 1 ? +(100 - share * (slots.length - 1)).toFixed(2) : share
  }));
};

export const SlotsStep = ({ slots, onChange, templates, loadingTemplates }) => {
  const [selectedTemplate, setSelectedTemplate] = useState(null);

  useEffect(() => {
    if (!slots.length && templates?.length) {
      setSelectedTemplate(templates[0].name);
      onChange(templates[0].slots);
    }
    // eslint-disable-next-line
  }, [templates]);

  const applyTemplate = (template) => {
    setSelectedTemplate(template.name);
    onChange(template.slots);
  };

  const renameSlot = (index, name) => {
    const next = [...slots];
    next[index] = { ...next[index], name };
    onChange(next);
  };

  const removeSlot = (index) => {
    onChange(redistribute(slots.filter((_, i) => i !== index)));
  };

  const addSlot = () => {
    onChange(redistribute([...slots, { name: `Meal ${slots.length + 1}` }]));
  };

  return (
    <div className="meal-planner-step">
      <h2 className="meal-planner-step__title">How many meals a day?</h2>
      <p className="meal-planner-step__sub">Start from a template, then rename, add or remove meals.</p>

      {!loadingTemplates && (
        <div className="meal-planner-step__templates">
          {(templates ?? []).map((template) => (
            <button
              key={template.name}
              type="button"
              className={`meal-planner-step__template${selectedTemplate === template.name ? ' active' : ''}`}
              onClick={() => applyTemplate(template)}
            >
              {template.name}
            </button>
          ))}
        </div>
      )}

      <div className="meal-planner-step__slot-list">
        {slots.map((slot, index) => (
          <div key={index} className="meal-planner-step__slot-row">
            <Input
              value={slot.name}
              onChange={({ value }) => renameSlot(index, value)}
              placeholder={`Meal ${index + 1}`}
            />
            <Button secondary small onClick={() => removeSlot(index)} disabled={slots.length <= 1}>
              Remove
            </Button>
          </div>
        ))}
      </div>

      <Button secondary onClick={addSlot} className="meal-planner-step__add-slot">
        + Add a meal
      </Button>
    </div>
  );
};
